module.exports = __webpack_public_path__ + "assets/img/bannoubiz.072c36b0.svg";